import ServicePageTemplate from "@/components/ServicePageTemplate";

const DryFreight = () => (
  <ServicePageTemplate
    seoTitle="Dry Van Freight | Varstar Alliance"
    seoDesc="Dry van freight transportation across the US and Canada. 53' and 48' dry van capacity for general commodities with live tracking on every shipment."
    canonical="/services/dry-freight"
    h1="The workhorse of freight."
    subtitle="Standard dry van transportation for general commodities — moving across all 48 states and Canada."
    ctaText="Get a Dry Freight Quote"
    body={"Most freight moves in dry vans, and dry van capacity is what we run every day. With our hybrid asset + brokerage network, you get covered loads at competitive rates, live GPS tracking, and the cross-border expertise to move freight in either direction across the US-Canada line."}
    benefits={[
      "Guaranteed capacity through asset + brokerage hybrid",
      "Competitive rates backed by volume leverage",
      "Live GPS tracking on every shipment",
      "Cross-border expertise for US-Canada lanes",
      "53' and 48' dry van equipment",
    ]}
    equipment={["53' Dry Van", "48' Dry Van", "Pup Trailer"]}
    weightLimit="45,000 lbs"
  />
);

export default DryFreight;